import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-247" data-mp="3mf7pufvy5mbi">
      <SectionHeading kicker="What other pediatric OT professionals are looking for" title="Practical Tools. Better Organization. A More Structured Workflow." data-id="element-248" data-mp="3r790jxdgv4zf" />

      <div className="mx-auto mt-10 max-w-6xl gap-6 md:columns-2 lg:columns-3" data-id="element-249" data-mp="42t0t5qe0hlv">
        {testimonials.map(t => <figure key={t.name} className="mb-6 break-inside-avoid rounded-[2rem] bg-white p-6 ring-1 ring-navy/10" data-id="element-250" data-mp="91e4xg8rflfl">
            <div className="flex items-center gap-4" data-id="element-251" data-mp="dzxqvgncsx7y">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-teal-soft" loading="lazy" data-id="element-252" data-mp="dymnhhxtlrhd" />
              <div data-id="element-253" data-mp="2ftew6do0hlzj">
                <p className="font-display text-lg font-bold text-navy" data-id="element-254" data-mp="2fsvorqvzmfzr">{t.name}</p>
                <p className="text-sm font-semibold text-ink-soft" data-id="element-255" data-mp="1slkoj78mmyfc">{t.role}</p>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-between gap-3" data-id="element-256" data-mp="1ns9ih8bn2loh">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-257" data-mp="1ivrg2f3s6zfb">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-sun text-sun" aria-hidden="true" data-id="element-258" data-mp="1euz2xarsgadr" data-mpi={i} />)}
              </div>
              <span className="rounded-full bg-teal-soft px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-teal-dark" data-id="element-259" data-mp="26kk31m2fdwxs">{t.topic}</span>
            </div>
            <blockquote className="mt-4 text-base leading-relaxed text-navy sm:text-lg" data-id="element-260" data-mp="22gvx17tfz9en">“{t.quote}”</blockquote>
          </figure>)}
      </div>

      <CtaButton label="Yes! I want the Pediatric OT Planning System™" className="mt-6" data-id="element-261" data-mp="r439683rv53v" />
    </section>;
}